import * as Yup from "yup";

import type { DirectDepositManualForm } from "./types";

const castInputToNumber = (val: unknown): number => {
  const parsedValue = parseInt(`${val}`, 10);
  if (Number.isNaN(parsedValue)) {
    return 0;
  }
  return parsedValue;
};

export const directDepositValidationSchema =
  Yup.object<DirectDepositManualForm>({
    accountId: Yup.string().required("Account required"),
    employer: Yup.string().required("Employer name required"),
    allocationMethod: Yup.string().required(),
    valuePercent: Yup.number()
      .nullable()
      .when("allocationMethod", {
        is: "percentage",
        then: (schema) =>
          schema
            .transform(castInputToNumber)
            .required("Percentage required")
            .min(1, "Must be at least 1%")
            .max(100, "Must be less than 100%"),
        otherwise: (schema) => schema.nullable(),
      }),
    valueCents: Yup.number()
      .nullable()
      .when("allocationMethod", {
        is: "cents",
        then: (schema) =>
          schema
            .transform(castInputToNumber)
            .required("Dollar amount required")
            .min(1, "Must be at least $0.01"),
        otherwise: (schema) => schema.nullable(),
      }),
  });
